/**
 * SuperAdminGate — Higher-order wrapper.
 * Si el usuario es SUPER_ADMIN y NO está en modo auditoría (sin audit_tenant_id),
 * muestra la Vista Global del módulo. En cualquier otro caso renderiza la página normal.
 *
 * Uso en App.js:
 *   <Route path="/waste" element={
 *     <SuperAdminGate moduleName="Gestión de Residuos" apiEndpoint="/waste/superadmin/overview">
 *       <Waste />
 *     </SuperAdminGate>
 *   } />
 */
import { useAuth } from "../lib/auth";
import SuperAdminModuleView from "./SuperAdminModuleView";

export default function SuperAdminGate({ moduleName, apiEndpoint, children }) {
  const { user } = useAuth();
  const isSuper = (user?.role || "").toUpperCase() === "SUPER_ADMIN";
  // Si el super_admin está en modo auditoría (audit_tenant_id presente)
  // dejamos pasar la vista normal filtrada por ese tenant.
  if (isSuper && !user?.audit_tenant_id) {
    return <SuperAdminModuleView moduleName={moduleName} apiEndpoint={apiEndpoint} />;
  }
  return children;
}
